import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");

@Injectable({
  providedIn: 'root'
})
export class TimeOffService {
  private url = GlobalService.serverURL + "recruiter/manage_timeoff/";
  constructor(private http: HttpClient) {}
  
  getList(data){
    return this.http.post(this.url + "get_policy_company", data, { headers: headers });
  }
  getEmpList(data){
    return this.http.post(this.url + "assign_emp_list", data, { headers: headers });
  }
  getPolicyType(data){
    return this.http.post(this.url + "get_policy", data, { headers });
  }
  createPolicy(data) {
    return this.http.post(this.url + "create_policy", data, { headers });
  }
  assignPolicy(data){
    return this.http.post(this.url + "assign_policy", data, { headers });
  }
  approveRejectPoilicy(data){
    return this.http.post(this.url + "company_approve_timeoff", data, { headers });
  }
  getRequestList(data){
    return this.http.post(this.url + "company_get_timeoff_request", data, { headers });
  }
  getEditItem(data){
    return this.http.post(this.url + "company_edit_employee_timeoff", data, { headers });
  }
  getInsight(data){
    return this.http.post(this.url + "company_get_insight", data, { headers });
  }
  getUserWise(data){
    return this.http.post(this.url + "emp_wise_timeoff_req", data, { headers });
  }
  getPolicyForemp(data){
    return this.http.post(this.url + "get_policy_employee", data, { headers });    
  }
  deletePolicy(data){
    return this.http.post(this.url + "delete_policy", data, { headers });    
  }
  editReq(data){
    return this.http.post(this.url + "company_edit_employee_timeoff", data, { headers });    
  }
  addReq(data){
    return this.http.post(this.url + "employee_add_timeoff", data, { headers });    
  }
  getManagePolicyData(data){
    return this.http.post(this.url + "policy_assign_rec", data, { headers });    
  }
}
